import React, { useEffect, useState, createContext, useCallback } from 'react';
import Login from './Login';
import AppMain from './AppMain';
import fetchInterceptor from './helpers/fetchInterceptor';
import { useDispatch } from 'react-redux';
import { Spinner } from 'react-bootstrap';
import { initializeKeycloak } from './keycloak';

export const AuthenticationContext = createContext(null);

const App = () => {
  const [keycloak, setKeycloak] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    const initKeycloak = async () => {
      try {
        const _keycloak = await initializeKeycloak();
        setIsAuthenticated(_keycloak?.authenticated || false);
        setKeycloak(_keycloak);
      } catch (error) {
        console.error('Failed to initialize Keycloak:', error);
      }
    };

    initKeycloak();
  }, []);

  useEffect(() => {
    const originalFetch = window.fetch;

    if (!keycloak) return;

    const initializeApp = async () => {
      try {
        setLoading(true);
        const response = await fetch('/api/networkchecker', { method: 'GET' });
        const data = await response.json();
        window.awpIsOnline = data?.status ?? false;
      } catch (error) {
        console.error('Network check failed:', error);
        window.awpIsOnline = false;
      } finally {
        window.fetch = (...args) => fetchInterceptor(dispatch, keycloak, args);
        setLoading(false);
      }
    };

    initializeApp();

    return () => {
      window.fetch = originalFetch;
    };
  }, [keycloak, dispatch]);

  if (loading) {
    return (
      <div className="text-center mt-4">
        <p>Loading SAWSx...</p>
        <Spinner animation="border" />
      </div>
    );
  }

  const appContent = isAuthenticated || !window.awpIsOnline ? <AppMain /> : <Login />;

  return (
    <AuthenticationContext.Provider value={keycloak}>
      <div className="App d-flex flex-column min-vh-100">{appContent}</div>
    </AuthenticationContext.Provider>
  );
};

export default App;
